export default {
    delete_clip_request_title: "Delete Clip",
    delete_clip_request_success_message: "The clip has been deleted",
    delete_clip_request_error_message: "The clip could not be deleted",
    delete_clip_request_message: "Are you sure you want to delete the clip?",
}